/** Keep the OIDC callback short; the requested application route stays in this tab. */
export function keycloakRedirectUri(origin: string): string {
  return origin + "/";
}

export function rememberKeycloakReturnUrl(
  location: Pick<Location, "pathname" | "search" | "hash">,
  storage: Pick<Storage, "setItem">,
): void {
  const { pathname, search, hash } = location;
  if (pathname === "/" || !pathname.startsWith("/") || pathname.startsWith("//")) return;
  const params = new URLSearchParams(search);
  // Never restore an expired authorization code from an older deep-link callback.
  if (params.has("state") && (params.has("code") || params.has("error"))) {
    ["state", "code", "session_state", "iss", "error", "error_description"].forEach(key => params.delete(key));
  }
  const query = params.toString();
  storage.setItem("redirectAfterLogin", pathname + (query ? "?" + query : "") + hash);
}
